import React from "react"
import { createSelectorHook, ReactReduxContextValue } from "react-redux"
import { SearchState } from "./store"

const SearchReduxContext =
  React.createContext<ReactReduxContextValue<SearchState> | null>(null)
export default SearchReduxContext

export const useSearchSelector =
  createSelectorHook(SearchReduxContext).withTypes<SearchState>()
